<template>
  <div class="time-condition-collapse">
    <div class="time-condition-collapse__header">
      <div class="time-condition-collapse__title" @click="is_collapse = !is_collapse">
        <icon :type="is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'" size="20" />
        <span class="time-condition-collapse__name">{{ item.name }}</span>
        <span class="time-condition-collapse__timezone">({{ item.timezone }})</span>
      </div>

      <div v-if="$slots['controls']" class="time-condition-collapse__controls">
        <slot name="controls"></slot>
      </div>
    </div>
    <div
      v-show="!is_collapse && format_worktime_items.length"
      class="time-condition-collapse__content"
    >
      <work-time-list :items="format_worktime_items" />
    </div>
  </div>
</template>

<script>
  import WorkTimeList from '@pbx/components/time-conditions/_fragments/worktime/list';
  import { groupByDay } from '@pbx/helpers/time-conditions/work-time';

  export default {
    components: { WorkTimeList },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      is_collapse: true
    }),

    computed: {
      format_worktime_items: function() {
        return groupByDay(this.item.worktimes);
      }
    }
  };
</script>

<style lang="scss">
  .time-condition-collapse {
    font-size: 14px;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    border-bottom: 1px solid $grey;
    padding-top: 10px;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &__title {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
    }

    &__name {
      margin-left: 5px;
      margin-right: 5px;
    }

    &__timezone {
      color: $blue-grey-light;
    }

    &__content {
      padding-bottom: 10px;
      padding-left: 25px;
    }
  }
</style>
